export const nullUpdateFn = (params) => params;
export const createAddQueryParamsFn = (queryParams = {}) => (params) => {
    Object.entries(queryParams).forEach(([key, value]) => {
        params.set(key, value);
    });
    return params;
};
export const createRemoveQueryParamsFn = (keyList = []) => (params) => {
    keyList.forEach((key) => {
        params.delete(key);
    });
    return params;
};
export const composeURLUpdateFns = (fns) => (params) => fns.reduce((acc, fn) => fn(acc), params);
export const updateURLWith = (updates, shouldReload = false, historyMethod = 'replaceState') => {
    const addFn = (updates === null || updates === void 0 ? void 0 : updates.add) ? createAddQueryParamsFn(updates.add) : nullUpdateFn;
    const removeFn = (updates === null || updates === void 0 ? void 0 : updates.remove) ? createRemoveQueryParamsFn(updates.remove) : nullUpdateFn;
    const updateFn = composeURLUpdateFns([
        addFn,
        removeFn,
        ...((updates === null || updates === void 0 ? void 0 : updates.fn) ? [].concat(updates.fn) : []),
    ]);
    const url = new URL(window.location.href);
    const { searchParams } = url;
    const newParams = updateFn(searchParams);
    const newUrl = `${url.origin}${url.pathname}?${newParams.toString()}`;
    window.history[historyMethod]({}, '', newUrl);
    if (shouldReload) {
        window.location.reload();
    }
};
